import React from "react";
import PricingSection from "../components/landing/modern/PricingSection";
import ModernFooter from "../components/landing/modern/ModernFooter";
import Navbar from "../components/landing/modern/Navbar";

const PricingPage: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#EBF5FF' }}>
      <Navbar />
      <div className="pt-20"> {/* Add padding to account for fixed navbar */}
        <PricingSection />
      </div>
      <ModernFooter />
    </div>
  );
};

export default PricingPage;